/**
 * Toasts class definition.
 */
class Toasts {

  toasts = {};

  constructor() {
    (($) => {
      const $toasts = $('.toast');

      $toasts.each((index, element) => {
        const $toast = $(element);
        const id = $toast.data('toast');

        if (id) {
          this.toasts[id] = new bootstrap.Toast($toast[0]);
        }
      });
    })(jQuery);
  }

  /**
   * Displays a toast based on its unique [data-toast] identifier.
   *
   * @param {string} id The toast's unique [data-toast] identifier.
   */
  show = (id) => {
    if (Object.prototype.hasOwnProperty.call(this.toasts, id)) {
      this.toasts[id].show();
    }
  }
}

const toasts = new Toasts();

window.toasts = Toasts;

export default toasts;
